module.exports = __webpack_public_path__ + "img/p3-1.2856ed3e.png";